import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { motion } from "framer-motion";
import swal from "sweetalert";
import { useHistory } from "react-router-dom";
import makeAnimated from "react-select/animated";

import commoncss from "../../css/common.module.css";
import { updateGroupingApiHandler } from "../../../WorkSpace/Components/ApiServices/apiHandler";
import InputGroup from "../../elements/InputGroup";
import saCreationcss from "../../css/standaloneCreation.module.css";

/**
 * @param {boolean} isReadOnly  --> SINGLE FLAG to disable ALL edits/actions
 */
const GeneralTemplateInfo = ({
  templateData,
  setHandleSave,
  handleSave,
  isReadOnly = false, // ✅ default editable
}) => {
  const animatedComponents = makeAnimated();
  const history = useHistory();
  const dispatch = useDispatch();

  const [parentTemplateName, setParentTemplateName] = useState(
    templateData?.parentTemplateData?.name
  );
  const [templateName, setTemplateName] = useState(templateData?.name);
  const [templateDesc, setTemplateDesc] = useState(templateData?.description);

  const [libraryName] = useState("ST Library");

  useEffect(() => {
    setParentTemplateName(templateData?.parentTemplateData?.name);
    setTemplateName(templateData?.name);
    setTemplateDesc(templateData?.description);
  }, [templateData]);

  /* -------------------- SAVE HANDLER -------------------- */
  useEffect(() => {
    // 🚫 Block save completely when read-only
    if (isReadOnly) return;

    if (handleSave === "general") {
      setHandleSave(null);

      const payload = {
        name: templateName,
        description: templateDesc,
      };

      updateGroupingApiHandler(
        { groupingTemplateID: templateData._id },
        payload
      )
        .then((response) => {
          if (response?.data?.success === true) {
            swal("Custom template updated successfully", "", "success");
          } else {
            swal(
              "Error",
              response?.data?.error || "Unable to update custom template",
              "error"
            );
          }
        })
        .catch((error) => {
          swal(
            "Error",
            error?.response?.data?.error || "Unable to update custom template",
            "error"
          );
        });
    }
  }, [handleSave, isReadOnly, templateName, templateDesc, setHandleSave, templateData]);

  return (
    <motion.div
      initial={{ x: 500, y: 500, opacity: 0 }}
      animate={{ x: 0, y: 0, opacity: 1 }}
      exit={{ x: 0, y: 0, opacity: 0 }}
      transition={{ duration: 0.7, ease: "easeInOut" }}
      className={saCreationcss.wsCrtNameDiv}
      style={{ border: "0px", marginTop: "2%" }}
    >
      <span
        className={`${saCreationcss.wsCreationCatHeading} ${commoncss.fs32}`}
      >
        Standalone Template
      </span>

      <span className="w-50">
        <div
          className={`${commoncss.inputCol}`}
          style={{ marginTop: "36px" }}
        >
          {/* Parent Template */}
          <InputGroup
            class2_={commoncss.gap20}
            label="Parent Template"
            inputs={[
              <InputGroup
                key="parent"
                inputs={[
                  <input
                    type="text"
                    placeholder="Parent Template Name here"
                    value={parentTemplateName || ""}
                    disabled
                  />,
                ]}
              />,
            ]}
          />

          {/* Template Name */}
          <InputGroup
            class2_={commoncss.gap20}
            label="Template Name"
            inputs={[
              <InputGroup
                key="name"
                inputs={[
                  <input
                    type="text"
                    placeholder="Template name here"
                    value={templateName || ""}
                    disabled={isReadOnly}
                    onChange={(e) => {
                      if (isReadOnly) return;
                      setTemplateName(e.target.value);
                    }}
                  />,
                ]}
              />,
            ]}
          />

          {/* Template Description */}
          <InputGroup
            class2_={commoncss.gap20}
            label="Template Description"
            inputs={[
              <InputGroup
                key="desc"
                inputs={[
                  <textarea
                    placeholder="Enter Template Description"
                    value={templateDesc || ""}
                    disabled={isReadOnly}
                    onChange={(e) => {
                      if (isReadOnly) return;
                      setTemplateDesc(e.target.value);
                    }}
                  />,
                ]}
              />,
            ]}
          />
        </div>
      </span>
    </motion.div>
  );
};

export default GeneralTemplateInfo;
